import { Component } from '@angular/core';

@Component({
    selector: 'app-faturar',
    templateUrl: './faturar.component.html',
    styleUrl: './faturar.component.css',
    standalone: false
})
export class FaturarComponent {

}
